module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f47a.97af278e.svg";